import React, { useState } from 'react';
import { Information } from '@carbon/react/icons';
import AliasGroupPill, { type AliasGroupPillState } from './alias-group-pill';
import AliasClusterGraph from './alias-cluster-graph';
import { useAliasCluster } from './use-alias-cluster';
import styles from './alias-cluster-button.module.scss';

interface AliasClusterButtonProps {
  // Pill display state, computed by the host from the visible match list.
  state: AliasGroupPillState;
  // The entity this is attached to — used to fetch + center the graph.
  entityId: number;
}

// The alias-group affordance on the Entity Classification field (mock
// entity-reconciliation v3): the dotted-underline "Group N (+ Others)" label
// plus a circled-ⓘ icon. Clicking the ⓘ lazy-fetches the cluster and opens the
// AliasClusterGraph centered on this entity.
const AliasClusterButton: React.FC<AliasClusterButtonProps> = ({
  state,
  entityId,
}) => {
  const [open, setOpen] = useState(false);
  const { members, edges, fetchCluster } = useAliasCluster(entityId);

  const handleOpen = () => {
    void fetchCluster();
    setOpen(true);
  };

  return (
    <span className={styles.wrap}>
      <AliasGroupPill state={state} />
      <button
        type="button"
        className={styles.info}
        aria-label="View alias cluster"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleOpen();
        }}
      >
        <Information size={16} />
      </button>
      <AliasClusterGraph
        open={open}
        onClose={() => setOpen(false)}
        selectedEntityId={String(entityId)}
        members={members}
        edges={edges}
      />
    </span>
  );
};

export default AliasClusterButton;
